/* global axios */
import ApiClient from './ApiClient';

class CatalogProductsAPI extends ApiClient {
  constructor() {
    super('catalog_products', { accountScoped: true });
  }

  get(inboxId, params = {}) {
    const url = `/api/v1/accounts/${this.accountIdFromRoute}/inboxes/${inboxId}/catalog_products`;
    return axios.get(url, { params });
  }
}

export default new CatalogProductsAPI();
